module.exports = "pegasus_template/assets/preview-3.png";